import React from 'react'

import CounterChart from '../../_shared/charts/counter/CounterChart'
import FormRepliesCounterLoader, {
  useAllFormRepliesCounter,
  useFormRepliesCounter
} from './_load/FormRepliesCounterLoader'
import WidgetWrapper from '../../WidgetWrapper'

const Widget = props => {
  const { widget } = props
  const value = useFormRepliesCounter()
  const all = useAllFormRepliesCounter()

  return <CounterChart value={value} all={all} name={widget.name} {...widget.data} />
}

const Wrapper = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <FormRepliesCounterLoader widget={widget}>
        <Widget widget={widget} />
      </FormRepliesCounterLoader>
    </WidgetWrapper>
  )
}

export default Wrapper
